/* Inline SVG icons. */
export const ArrowLeft = () => (
	<svg viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="1.5">
		<path d="M15 18l-6-6 6-6" />
	</svg>
);

export const ArrowRight = () => (
	<svg viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="1.5">
		<path d="M9 18l6-6-6-6" />
	</svg>
);

export const PlayIcon = () => (
	<svg viewBox="0 0 24 24" width="18" height="18" fill="#1c1917">
		<path d="M8 5v14l11-7z" />
	</svg>
);

export const CloseIcon = () => (
	<svg viewBox="0 0 24 24" width="16" height="16" fill="none" stroke="currentColor" strokeWidth="1.5">
		<path d="M18 6L6 18M6 6l12 12" />
	</svg>
);

export const DocIcon = () => (
	<svg viewBox="0 0 24 24" width="20" height="24" fill="none" stroke="currentColor" strokeWidth="1.4">
		<path d="M14 2H6a2 2 0 0 0-2 2v16a2 2 0 0 0 2 2h12a2 2 0 0 0 2-2V8z" />
		<path d="M14 2v6h6M8 13h8M8 17h8M8 9h2" />
	</svg>
);
